"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GroupedStackedBarChart;
var _react = _interopRequireWildcard(require("react"));
var d3 = _interopRequireWildcard(require("d3"));
var _useBreakPoint = require("../../../common/useBreakPoint");
var _util = require("./util");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-stacked-barchart-container {\n  position: relative; }\n  .sia-stacked-barchart-container .xAxis {\n    font-family: 'Helvetica Neue LT Roman';\n    font-size: 12px;\n    color: #000000; }\n  .sia-stacked-barchart-container .yAxis {\n    font-family: 'Helvetica Neue LT Roman';\n    font-size: 16px;\n    color: #000000; }\n  .sia-stacked-barchart-container .bar-value {\n    font-family: 'Helvetica Neue LT Roman';\n    font-size: 12px;\n    line-height: 12px;\n    fill: #000000; }\n  .sia-stacked-barchart-container .tooltip-inner {\n    position: absolute;\n    background-color: #ffffff;\n    border: 1px solid #000000;\n    display: flex;\n    justify-content: space-between;\n    gap: 16px;\n    align-items: center;\n    padding: 8px;\n    width: fit-content; }\n  .sia-stacked-barchart-container .legend-container {\n    max-width: 100%;\n    max-height: 100%;\n    height: 100%;\n    overflow-x: scroll;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    scrollbar-width: none; }\n  .sia-stacked-barchart-container .legend-row {\n    display: flex;\n    justify-content: space-between;\n    gap: 16px; }\n  .sia-stacked-barchart-container .legend-item {\n    display: flex;\n    justify-content: space-between;\n    gap: 10px; }\n";
  const fileName = "StackedBarchart_StackedBarchart";
  const element = document.querySelector("style[data-sass-component='StackedBarchart_StackedBarchart']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
function GroupedStackedBarChart(_ref) {
  let {
    data,
    bandWidth,
    isPercentage,
    options
  } = _ref;
  const containerRef = (0, _react.useRef)();
  const ref = (0, _react.useRef)();
  const {
    isMobile
  } = (0, _useBreakPoint.useBreakPoint)();
  (0, _react.useEffect)(() => {
    let marginLeft = isMobile ? 150 : 250;
    const marginBottom = 40;
    d3.select(ref.current).selectAll('*').remove();
    let container = containerRef.current;
    let {
      width
    } = container.getBoundingClientRect();
    let groups = Array.from(new Set(data.map(d => d.group)));
    const subgroups = Array.from(new Set(data.map(d => d.subgroup))).sort(a => a.toLowerCase() === 'average' ? -1 : 1);
    const legendSpace = isPercentage ? 100 : 50;
    const svgHeight = bandWidth * groups.length + legendSpace;
    const stackKeys = Object.keys(data[0]).filter(e => !['group', 'subgroup'].includes(e));
    const groupedData = d3.groups(data, d => d.group);
    const x = (0, _util.createXScale)(isPercentage, data, stackKeys, marginLeft, width);
    const y0 = (0, _util.createYScale)(groups, svgHeight - legendSpace);
    const y1 = (0, _util.createYScale)(subgroups, y0.bandwidth());
    const WHITE_BETWEEN_RECTS_WIDTH = 1;
    const gradients = (0, _util.getGradients)(stackKeys.length - WHITE_BETWEEN_RECTS_WIDTH, options?.gradients);
    const svg = (0, _util.createSvg)(ref, width, svgHeight);
    (0, _util.addAxisToSvg)(svg, 0, svgHeight - legendSpace, 'bottom', x, 'xAxis');
    (0, _util.addAxisToSvg)(svg, marginLeft, 0, 'left', y0, 'yAxis', 16);
    (0, _util.drawRects)(svg, isPercentage, groupedData, x, y0, y1, stackKeys, width, marginLeft, container, gradients);
    (0, _util.drawTicks)(width, marginLeft, marginBottom, svgHeight, legendSpace);
    if (isMobile) {
      (0, _util.rotateBottomTicks)(ref.current, y0);
    }
    (0, _util.drawLegend)(svgHeight, isPercentage, subgroups, svg, marginLeft, stackKeys, gradients);
  }, [data, isMobile, bandWidth, isPercentage, options?.gradients]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-stacked-barchart-container",
    ref: containerRef
  }, /*#__PURE__*/_react.default.createElement("svg", {
    ref: ref
  }));
}